import { Flex, Text, useToast } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useRef, useState } from "react";

const pKeyframes = keyframes`
  0% {
    rotate: 0deg;
  }
  100% {
    rotate: 360deg;
  }
`;

const WithdrawButton = ({
  disabled,
  onConfirm,
}: {
  disabled: boolean;
  onConfirm: () => void;
}) => {
  const [waveHeight, setWaveHeight] = useState(0);
  const [_, setReload] = useState(false);
  const timer = useRef<any>(null);
  const confirm = useRef<any>(null);

  const handleConfirm = () => {
    confirm.current = true;
    onConfirm();
  };

  const handleMouseDown = () => {
    if (disabled) {
      return;
    }

    timer.current = setInterval(() => {
      setWaveHeight((prevHeight) => {
        if (prevHeight < 200) {
          return prevHeight + 1;
        } else {
          clearInterval(timer.current);
          // 添加延时，等待动画完成
          setTimeout(() => {
            handleConfirm();
            setWaveHeight(0);
          }, 500); // 500ms 对应 transition 的时间
          return 200;
        }
      });
    }, 5);
  };

  const handleMouseUp = () => {
    timer.current && clearInterval(timer.current);
    setWaveHeight(0); // Reset the wave height when mouse is released
    if (!confirm.current) {
    }
  };

  return (
    <Flex
      sx={{
        position: "fixed",
        bottom: "0",
        left: "0",
        width: "100%",
        height: "100px",
        background: disabled ? "#BBBBBB" : "#D8762B",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        zIndex: 10,
        "& *": {
          userSelect: "none",
        },
        "&::after": {
          userSelect: "none",
          content: '""',
          position: "absolute",
          top: `calc(100% - ${waveHeight}%)`,
          left: `50%`,
          translate: "-50% 0",
          width: "200vw",
          height: "200vw",
          borderRadius: "85vw",
          background: "#FDA94D",
          animation: `${waveHeight > 0 && pKeyframes} 5s linear infinite`,
          transition: "top 0.5s", // 只对 top 属性应用过渡效果
        },
      }}
      align={"center"}
      justify={"center"}
    >
      <Flex
        onTouchStart={handleMouseDown}
        onTouchEnd={handleMouseUp}
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          height: "100%",
        }}
        align={"center"}
        justify={"center"}
        zIndex={1}
      >
        <Text
          sx={{
            color: disabled ? "#848484" : "#fff",
            fontSize: "30px",
            fontWeight: 700,
            marginRight: "12px",
          }}
        >
          Hold To Withdraw{" "}
        </Text>
      </Flex>
    </Flex>
  );
};

export default WithdrawButton;
